/**
 * The sound library, one SFX Lab recipe per file. The JSON files are the
 * source of truth — see README.md in this directory for how to edit one in
 * the lab and drop it back. `tools/verify-sfx.mjs` checks that this index,
 * the files on disk, and the voices `audio.js` asks for all agree.
 *
 * The import attribute keeps these loadable under plain Node as well as
 * Vite, which is what lets `npm test` import the audio layer directly.
 */
import aimWhisper from './aim-whisper.json' with { type: 'json' };
import ambientTwinkle from './ambient-twinkle.json' with { type: 'json' };
import comboFlourish from './combo-flourish.json' with { type: 'json' };
import fireworkBurst from './firework-burst.json' with { type: 'json' };
import fireworkCrackle from './firework-crackle.json' with { type: 'json' };
import fireworkLaunch from './firework-launch.json' with { type: 'json' };
import formationClear from './formation-clear.json' with { type: 'json' };
import gameOver from './game-over.json' with { type: 'json' };
import gameStart from './game-start.json' with { type: 'json' };
import gemCascade from './gem-cascade.json' with { type: 'json' };
import gemChime from './gem-chime.json' with { type: 'json' };
import grandCombo from './grand-combo.json' with { type: 'json' };
import newRecord from './new-record.json' with { type: 'json' };
import pyramidGrab from './pyramid-grab.json' with { type: 'json' };
import pyramidRelease from './pyramid-release.json' with { type: 'json' };
import stoneLift from './stone-lift.json' with { type: 'json' };
import stonePlace from './stone-place.json' with { type: 'json' };
import stoneReturn from './stone-return.json' with { type: 'json' };
import turnTickLeft from './turn-tick-left.json' with { type: 'json' };
import turnTickRight from './turn-tick-right.json' with { type: 'json' };
import uiClick from './ui-click.json' with { type: 'json' };

/** Every recipe, keyed by its id — which is also its filename. */
export const RECIPES = Object.fromEntries(
  [
    aimWhisper,
    ambientTwinkle,
    comboFlourish,
    fireworkBurst,
    fireworkCrackle,
    fireworkLaunch,
    formationClear,
    gameOver,
    gameStart,
    gemCascade,
    gemChime,
    grandCombo,
    newRecord,
    pyramidGrab,
    pyramidRelease,
    stoneLift,
    stonePlace,
    stoneReturn,
    turnTickLeft,
    turnTickRight,
    uiClick,
  ].map((recipe) => [recipe.id, recipe]),
);
